import { FormElement, FormId } from "../../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { provinces } from "../../../../../shared";
import { selectCountry } from "../../../../../store/HOC/genericUI.selectors";
import { peselMask, postalCodeMask } from "../../../../../utilities/masks";
import {
  selectIncidentDriverData,
  selectWasVehicleInMotion,
  selectIsPeselUndefined,
  selectUIData,
  selectCircumAvailableCities,
} from "../incident.selectors";
import {
  setAvailableCities,
  setLackOfPesel,
  setUIObjectField,
} from "../incident.slice";

import { ComponentId } from "./enums";

export const personalData: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INCIDENT_DRIVER,
  id: [FormId.INCIDENT_DRIVER, "personal-data"].join("-"),
  selector: selectIncidentDriverData,
  isVisible: selectWasVehicleInMotion,
  content: [
    {
      title: "Dane kierującego",
      sections: [
        {
          id: "incident-driver-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.DRIVER_NAME,
              label: "Imię",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.DRIVER_SURNAME,
              label: "Nazwisko",
            },
          ],
        },
        {
          id: "incident-driver-data-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              mask: peselMask,
              id: ComponentId.DRIVER_PESEL,
              disabled: selectIsPeselUndefined,
              label: "PESEL",
              required: true,
            },
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("driverphone"),
              id: ComponentId.DRIVER_PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
            },
          ],
        },
        {
          id: "applicant-driver-data-3",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.CHECKBOX,
              id: ComponentId.DRIVER_LACK_OF_PESEL,
              label: "",
              onChange: setLackOfPesel,
              items: [
                {
                  label: "Brak numeru PESEL",
                  value: "true",
                },
              ],
            },
          ],
        },
        {
          id: "incident-driver-data-4",
          wrapper: { xs: 12 },
          isVisible: selectIsPeselUndefined,
          components: [
            {
              type: FormElement.SELECT,
              id: ComponentId.DRIVER_OTHER_ID,
              label: "Rodzaj dokumentu",
              items: [
                {
                  label: "Dowód osobisty",
                  value: "idCard",
                },
                {
                  label: "Prawo jazdy",
                  value: "driverLicense",
                },
                {
                  label: "Paszport",
                  value: "passport",
                },
                {
                  label: "Karta stałego pobytu",
                  value: "permanentResidenceCard",
                },
                {
                  label: "inne",
                  value: "other",
                },
              ],
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.DRIVER_OTHER_ID_NUMBER,
              label: "Numer dokumentu",
            },
          ],
        },
      ],
    },
  ],
};

export const address: FormSchema<SimpleFormSchemaComponents> = {
  formId: FormId.INCIDENT_DRIVER,
  id: [FormId.INCIDENT_DRIVER, "address"].join("-"),
  selector: selectIncidentDriverData,
  isVisible: selectWasVehicleInMotion,
  content: [
    {
      sections: [
        {
          title: "Adres kierującego",
          id: "incident-driver-data-5",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.DRIVER_STREET,
              label: "Ulica",
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.DRIVER_STREET_2,
              label: "Numer budynku / mieszkania",
            },
          ],
        },
        {
          id: "incident-driver-data-6",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.DRIVER_ZIP_CODE,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              type: FormElement.SELECT_CITY,
              id: ComponentId.DRIVER_CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectCircumAvailableCities,
            },
          ],
        },
        {
          id: "incident-driver-data-7",
          wrapper: { xs: 12, sm: 6 },
          components: [
            {
              type: FormElement.SELECT,
              id: ComponentId.DRIVER_PROVINCE,
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
      ],
    },
  ],
};
